import { render, staticRenderFns } from "./SelectDiscoveredUsFrom.vue?vue&type=template&id=889d0c24&"
import script from "./SelectDiscoveredUsFrom.vue?vue&type=script&lang=ts&"
export * from "./SelectDiscoveredUsFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('889d0c24')) {
      api.createRecord('889d0c24', component.options)
    } else {
      api.reload('889d0c24', component.options)
    }
    module.hot.accept("./SelectDiscoveredUsFrom.vue?vue&type=template&id=889d0c24&", function () {
      api.rerender('889d0c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/SelectDiscoveredUsFrom.vue"
export default component.exports